<template>
    <div class="cookie" v-if="!close">
        <div class="wrapper">
            <div class="cookie__content">
                <p class="text">
                    We use cookies to ensure that we give you the best experience on our website. If you continue to use this site we will assume that you are giving consent to set cookies.
                </p>
                <p class="close" @click="cookieAgree()">+</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'cookie',

    data() {
        return {
            close: false,
        }
    },

    methods: {
        cookieAgree() {
            this.$cookie.set('c00kie', 'Informed!');
            this.$emit('cookieAccepted');
            this.close= true;
        }
    }
}
</script>

<style lang="scss" scoped>
    .cookie {
        width: 100%;
        height: 35px;
        position: fixed;
        bottom: 0;
        z-index: 500;
        background-color: #3b3d40;

        .wrapper {
            height: 100%;
        }

        &__content {
            height: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 0;
            padding: 0;

            .text {
                color: white;
                margin: 0 30px 0 0;
                font-size: 0.8rem;
                line-height: 0.8rem;
                max-width: initial;
            }

            .close {
                font-size: 30px;
                transform: rotate(45deg);
                margin: 0;
                color: black;
                cursor: pointer;
                transition: linear .2s;


                &:hover {
                    color: #ff5400;
                }
            }
        }
    }

    @media all and (max-width: 1200px) {
        .cookie {
            height: 55px;
            &__content{
                padding: 10px 8%;
            }
        }
    }

    @media all and (max-width: 830px) {

        .cookie {
            height: 65px;
            &__content{
                p {
                    padding: 0;
                }
            }
        }
    }

    @media all and (max-width: 380px) {
        .cookie {
            height: 75px;
            &__content{
                p {
                    padding: 0;
                }
            }
        }
    }

</style>